import React from 'react';

interface FavoriteIconProps {
  width?: number;
  height?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
  variant?: 'card' | 'menu';
  filled?: boolean;
}

export const FavoriteIcon: React.FC<FavoriteIconProps> = ({
  width,
  height,
  color,
  strokeWidth,
  className,
  variant = 'card',
  filled = false,
}) => {
  if (variant === 'menu') {
    return (
      <svg
        width={width ?? 20}
        height={height ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M9.50963 15.641L9.72358 15.8133L9.93818 15.6404C12.2934 13.7437 13.8794 12.4663 15.153 10.8681C19.208 5.77933 12.8762 0.92403 9.72358 5.4356C6.57094 0.92403 0.239268 5.77933 4.29424 10.8681C5.56791 12.4665 7.15412 13.744 9.50963 15.641ZM9.50963 15.641V15.641Z"
          stroke={color ?? '#939FA9'}
          strokeWidth={strokeWidth ?? 1.21622}
        />
      </svg>
    );
  }
  if (filled) {
    return (
      <svg
        width={width ?? 16}
        height={height ?? 16}
        viewBox="1.9 1.9 12.2 12.2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.81932 12.8605L7.99523 13.0022L8.17168 12.8601C10.1082 11.3005 11.4123 10.2503 12.4594 8.93616C15.7935 4.75206 10.5874 0.759932 7.99523 4.46945C5.40306 0.759932 0.197022 4.75206 3.53111 8.93616C4.57835 10.2504 5.88257 11.3008 7.81932 12.8605Z"
          fill={color ?? 'white'}
          fillOpacity={color ? undefined : 0.8}
        />
      </svg>
    );
  }
  return (
    <svg
      width={width ?? 16}
      height={height ?? 16}
      viewBox="1.3 1.4 13.4 13.4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M10.2037 2.51655C11.1552 2.41907 12.0803 2.75506 12.7789 3.36616C13.4791 3.97867 13.9631 4.87652 14.0319 5.91889C14.1008 6.96554 13.7493 8.11967 12.8502 9.248C11.7618 10.6138 10.4093 11.6993 8.485 13.249L7.99476 13.6445L7.5055 13.2499C5.58079 11.6999 4.22784 10.6141 3.13929 9.248C2.24019 8.11966 1.88966 6.96554 1.95863 5.91889C2.02743 4.87644 2.51133 3.97868 3.21156 3.36616C3.91011 2.75522 4.83447 2.41912 5.78578 2.51655C6.57405 2.59731 7.34487 2.97235 7.99476 3.67378C8.64464 2.97232 9.41547 2.59734 10.2037 2.51655ZM10.3063 3.51167C9.66666 3.5772 8.97952 3.93358 8.40492 4.75581L7.99476 5.34272L7.5846 4.75581C7.0101 3.93377 6.32372 3.57727 5.68421 3.51167C5.03468 3.44512 4.37992 3.67283 3.86976 4.11909C3.36122 4.56393 3.00632 5.2174 2.9557 5.98432C2.90538 6.74692 3.15373 7.66142 3.92152 8.62495C4.90346 9.85718 6.12448 10.8527 7.99476 12.3593C9.8651 10.8527 11.0861 9.85715 12.068 8.62495C12.8358 7.66141 13.0842 6.74693 13.0338 5.98432C12.9832 5.2174 12.6283 4.56393 12.1198 4.11909C11.6097 3.67303 10.9556 3.44528 10.3063 3.51167Z"
        fill={color ?? '#939FA9'}
      />
    </svg>
  );
};

export default FavoriteIcon;
